<mad-main-container>
  <mad-content-header>
    <div class="fx fx-row">
      <div class="fx fx-row fx-align-center">
        <button mat-button>
          <mat-icon color="primary" (click)="goToPreviousPage()">arrow_back</mat-icon>
        </button>
        <h2 class="title">Flow Bar layout</h2>
      </div>
    </div>
  </mad-content-header>
  <mad-flowbar #flowBar [steps]="steps" [activeStep]="activeStep" (activeStepChange)="activeStepChanged($event)"> </mad-flowbar>
  <mad-content-panel-container>
    <mad-content-panel-container-content>
      @for (a of [1, 2, 3, 4, 5, 6, 7, 8]; track a) {
        <p>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
          erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
          sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
          invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
          clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing
          elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam
          et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
        </p>
      }
    </mad-content-panel-container-content>
    <mad-content-panel-container-footer class="fx fx-align-center fx-space-between">
      <div class="fx fx-row">Current Step Info</div>
      <div class="fx fx-row">
        @if (flowBar.isPreviousAvailable()) {
          <mad-outline-button (click)="flowBar.previous()"> Previous </mad-outline-button>
        }
        @if (!flowBar.isLastStep()) {
          <mad-primary-button (click)="flowBar.next()"> Next </mad-primary-button>
        }
      </div>
    </mad-content-panel-container-footer>
  </mad-content-panel-container>
</mad-main-container>
